/**
 * 输入文案的笔刷
 * @param {*} fabric
 * @param {*} canvas
 * @returns
 */
export default function(fabric, canvas, options = {}) {
  return new fabric.DiagramBrush(canvas, {
    getObject(opt, pointer) {
      const scale = options.scale || 1
      const textConf = options.textConf || {}
      const fontSize = textConf.fontSize || 80
      return new fabric.Textbox('', {
        name: options.name,
        left: pointer.x,
        top: pointer.y - (fontSize / 2) * scale,
        originX: 'left',
        originY: 'top',
        fill: 'red',
        width: 150,
        editable: true,
        fontSize,
        ...textConf
      }).scale(scale)
    },
    /**
     * 物件添加后的回调
     * @param {*} brush
     */
    afterAdd(brush) {
      const { curObject, canvas } = brush
      canvas.setActiveObject(curObject)
      curObject.enterEditing()
      curObject.hiddenTextarea.focus()
    },
    renderMove(opt, pointer) {
      //
    },
    // 鼠标起来
    afterMouseUp(brush) {
      //
    }
  })
}